import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, DestroyRef, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterOutlet } from '@angular/router';
import { ContextService } from '../../core/context/context.service';
import { Header } from '../header/header';
import { Sidebar } from '../sidebar/sidebar';

@Component({
  selector: 'app-shell',
  imports: [Header, MatSidenavModule, RouterOutlet, Sidebar],
  templateUrl: './shell.html',
  styleUrl: './shell.scss',
})
export class Shell {
  private readonly breakpointObserver = inject(BreakpointObserver);
  private readonly destroyRef = inject(DestroyRef);

  readonly isMobile = signal(this.breakpointObserver.isMatched('(max-width: 800px)'));
  readonly drawerOpened = signal(!this.isMobile());

  constructor() {
    // The menu and launcher need the user's applications; pages that need more load it themselves.
    inject(ContextService).load().subscribe({ error: () => undefined });

    this.breakpointObserver
      .observe('(max-width: 800px)')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(({ matches }) => {
        this.isMobile.set(matches);
        this.drawerOpened.set(!matches);
      });
  }

  closeDrawerOnMobile(): void {
    if (this.isMobile()) {
      this.drawerOpened.set(false);
    }
  }
}
